import React, { useState } from 'react';

const GaugeChart = ({
    value = 50,
    maxValue = 100,
    title = "Commodity Necessity",
    description = "Lithium is rated 90 out of 100 for its essentiality. It's critical for all modern electronics and the electric vehicle industry",
    showLabels = true
}) => {
    // Calculate percentage for needle position
    const percentage = Math.min(value / maxValue, 1);
    
    // SVG dimensions
    const size = 200;
    const centerX = size / 2;
    const centerY = size / 2 + 10; // Center for top semicircle display
    const radius = 70;
    const strokeWidth = 12;
    
    // Calculate needle angle for TOP semicircle clockwise movement
    // 0% = 180° (west), 50% = 270° (north/up), 100% = 0° (east)
    const needleAngle = 180 + (percentage * 180); // 180° at 0%, 360°/0° at 100%
    const needleAngleRad = (needleAngle * Math.PI) / 180;
    const needleLength = radius - 5;
    const needleEndX = centerX + needleLength * Math.cos(needleAngleRad);
    const needleEndY = centerY + needleLength * Math.sin(needleAngleRad);

    // Create gauge segments with different colors
    const segments = [
        { start: 0, end: 25, color: '#87CEEB' },    // Light blue
        { start: 25, end: 50, color: '#4FC3F7' },   // Medium blue  
        { start: 50, end: 75, color: '#29B6F6' },   // Darker blue
        { start: 75, end: 100, color: '#1976D2' }   // Dark blue
    ];

    const createArcPath = (startPercent, endPercent) => {
        // For TOP semicircle clockwise: 0% = 180° (west), 50% = 270° (north), 100% = 0° (east)
        const startAngle = 180 + (startPercent / 100) * 180;
        const endAngle = 180 + (endPercent / 100) * 180;
        
        const startAngleRad = (startAngle * Math.PI) / 180;
        const endAngleRad = (endAngle * Math.PI) / 180;
        
        const startX = centerX + radius * Math.cos(startAngleRad);
        const startY = centerY + radius * Math.sin(startAngleRad);
        const endX = centerX + radius * Math.cos(endAngleRad);
        const endY = centerY + radius * Math.sin(endAngleRad);
        
        // For clockwise direction on top semicircle
        const largeArc = 0;
        
        return `M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArc} 1 ${endX} ${endY}`;
    };

    return (
        <div className="gauge-chart-container">
            <div className="gauge-chart-svg-wrapper">
                <svg width={size} height={size * 0.7} viewBox={`0 0 ${size} ${size * 0.7}`}>
                    <defs>
                        <filter id="glow">
                            <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                            <feMerge>
                                <feMergeNode in="coloredBlur"/>
                                <feMergeNode in="SourceGraphic"/>
                            </feMerge>
                        </filter>
                    </defs>

                    <path
                        d={createArcPath(0, 100)}
                        fill="none"
                        stroke="#1a1a2e"
                        strokeWidth={strokeWidth + 2}
                        strokeLinecap="round"
                    />

                    {segments.map((segment, index) => (
                        <path
                            key={index}
                            d={createArcPath(segment.start, segment.end)}
                            fill="none"
                            stroke={segment.color}
                            strokeWidth={strokeWidth}
                            strokeLinecap="round"
                        />
                    ))}

                    <circle
                        cx={centerX}
                        cy={centerY}
                        r="4"
                        fill="#ffffff"
                    />

                    <line
                        x1={centerX}
                        y1={centerY}
                        x2={needleEndX}
                        y2={needleEndY}
                        stroke="#ffffff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        filter="url(#glow)"
                    />
                </svg>

                <div className="gauge-chart-value">
                    {/* {value}% */}
                </div>
            </div>

            {showLabels && (
                <>
                    <h2 className="gauge-chart-title">
                        {title}
                    </h2>

                    <p className="gauge-chart-description">
                        {description}
                    </p>
                </>
            )}
        </div>
    );
};

export default GaugeChart;